export default __webpack_public_path__ + "static/char-v-03-e843d2a86a0d5118236b1f776a4db0b1.mp4";